module.exports = __webpack_public_path__ + "static/media/HalfTheTruthIsAWholeLieArt_200.01623669.jpg";